import { MagpieConnection } from 'magpie-lib/connection';
import PortalIdParser from 'PortalIdParser';
import { Tags } from 'magpie-types/tags';
import { useRef } from 'react';
export const useSetupMagpie = appName => {
  const wasCalled = useRef(false);
  // eslint-disable-next-line react-hooks/refs
  if (wasCalled.current) {
    return;
  }
  try {
    MagpieConnection.create({
      appName,
      tags: [Tags.APP],
      portalId: PortalIdParser.get(),
      debug: true,
      onConnectionError: error => {
        console.log(error);
      }
    });
    // eslint-disable-next-line react-hooks/refs
    wasCalled.current = true;
  } catch (error) {
    console.log(error);
  }
};